import { __assign } from 'tslib';
import * as React from 'react';

var HamburgerIcon = function (props) {
    return (React.createElement("svg", __assign({ height: 20, viewBox: "0 0 100 80", width: 20 }, props),
        React.createElement("path", { d: "M0 0h100v8H0zM0 30h100v8H0zM0 60h100v8H0z" })));
};

export { HamburgerIcon as default };
//# sourceMappingURL=HamburgerIcon.esm.js.map
